// admin-api's pre-token generation refuses the portal to users whose only role is store staff, and
// Cognito passes its message on as "PreTokenGeneration failed with error <message>."
const storeStaffRefusal = "store staff sign in to the MPOS app"

export const isStoreStaffRefusal = (error: unknown) =>
  error instanceof Error && error.message.includes(storeStaffRefusal)

/** Runs a sign-in step, and calls onRefused when admin-api turns the user away as store staff */
export async function refusingStoreStaff<T>(step: () => Promise<T>, onRefused: () => void) {
  try {
    return await step()
  } catch (e) {
    if (isStoreStaffRefusal(e)) onRefused()
    throw e
  }
}
